import "./NursingCareProviderInHaifaWithinHours.module.css";
import Header from "@/reusable_sections/Header";
import PacificNorthwestLocalServiceHero from "./sections/PacificNorthwestLocalServiceHero";
import RelatedServicesGrid from "./sections/RelatedServicesGrid";
import RelatedServices from "./sections/RelatedServices";
import FaqAccordion from "./sections/FaqAccordion";
import FinalCta from "./sections/FinalCta";
import Footer from "@/reusable_sections/Footer";
export default function NursingCareProviderInHaifaWithinHoursPage() {
  return <div>
      <Header />
      <PacificNorthwestLocalServiceHero />
      <RelatedServicesGrid />
      <RelatedServices />
      <FaqAccordion />
      <FinalCta />
      <Footer />
    </div>;
}